import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TitleService {
	pageTitle = new BehaviorSubject('');

	constructor(private title: Title, private translate: TranslateService) {
		this.translate.onLangChange.subscribe(() => this.setTitle());
		this.pageTitle.subscribe(() => this.setTitle());
	}

	setTitle(): void {
		const translatedTitle = this.translate.instant(this.pageTitle.value);
		const pageTitle = this.translate.instant('PAGE_TITLE.HOME');
		const updatedTitle = `${pageTitle} - ${translatedTitle}`;
		this.title.setTitle(updatedTitle);
		if ((document as any).eventListeners('titleChanged')[0])
			(document as any).eventListeners('titleChanged')[0](updatedTitle);
	}

	getTitle(): string {
		return this.title.getTitle();
	}
}
